import { BuildingLibraryIcon, BuildingOfficeIcon } from "@heroicons/vue/24/outline";
const mediaUrl = process.env.VUE_APP_BASE_MEDIA_URL;

export const QUALIFICATIONS = {
    TOP_A: {
        label: 'TOP-Ausbildungsbetrieb',
        key: 'istopa', // kein Qualifikations-Eintrag der API, sondern das Flag `istopa` (stabiler Schlüssel für v-for)
        icon: null,
        image: `icons/topa_gold.png`,
    },
    ZQ_VACATION_SCHOOL: {
        label: 'Teilnahme am Dualen Berufskolleg',
        key: 'Teilnahme am Dualen Berufskolleg',
        icon: BuildingLibraryIcon,
        image: null,
    },
    ZQ_HOTEL_MANAGEMENT: {
        label: 'ZQ Hotelmanagement',
        key: 'Zusatzqualifikation Hotelmanagement (für Hotelfachleute)',
        icon: BuildingOfficeIcon,
        image: null,
    },
    ZQ_KITCHEN: {
        label: 'ZQ Küchen- und Servicemanagement',
        key: 'Zusatzqualifikation Küchen- und Servicemanagement (für Restaurantfachleute und Köche)',
        icon: null,
        image: `icons/fhg_gold.png`,
    },
}